import initializeNewGroupUA from '../../helpers/assessment/initializeNewGroupUA'
import { db } from "../../config/firebaseconfig";
/**
 * Updates state after requestGroupUAUpdate returns
 * @param {string} res The returned string from requestGroupUAUpdate
 * @param {object} groupUAs The object containing all groupUAs the user has access to
 * @param {string} selectedGroupUA The id of the selectedGroupUA currently in view
 * @param {number} year The active year
 * @param {string} assessmentId The set id of the assessment currently in view
 * @param {object} actions fetchingGroupUAsSuccess and either refreshingSuccess or setState
 * @param {boolean} selector_call true if called from the AssessSelectorBar
 */
export default function processGroupUAUpdate (
  res, 
  groupUAs, 
  selectedGroupUA,
  year,
  assessmentId, 
  actions,
  selector_call
) {
  let newGroupUAs

  if (res) {
    let data = JSON.parse(res); 
    if(data.action === 'initiateBlankGUA'){ 
      //init blankGUA
        let sets = {}
        let items = {}
        // Fetch all sets. Sets are groups of items and sets that are used to
        // as assessments or parts of assessments.
        const getSets = db.collection('sets').get()
          .then((querySnapshot) => {
            querySnapshot.forEach((setDoc) => {
              const setDocData = setDoc.data()
              sets[setDocData.id] = setDocData
            })
          })
          .catch((err) => console.log(err))
          
        // Fetch all content items. Each assessment question is one contentItem.
        const getItems = db.collection('contentItems').get()
          .then((querySnapshot) => {
            querySnapshot.forEach((contentItem) => {
              const contentItemData = contentItem.data()
              items[contentItemData.itemId] = contentItemData
            })
          })
          .catch((err) => console.log(err))
        Promise.all([getSets, getItems])
        .then(() => { 
          const { id, groupType } = data;
           const blankGUA = initializeNewGroupUA(assessmentId, sets, items, id, groupType, `sy${year}`)

           db.collection('groupUA').doc(id).get()
           .then((doc) => {
             if(doc.exists){
                const resetGroupUA = {
                 ...doc.data(),
                   [`sy${year}`]: {
                     [assessmentId]: {
                       ...blankGUA
                     }
                   }
               }  
              db.collection('groupUA').doc(id).update(resetGroupUA)

              const GUA = resetGroupUA
              newGroupUAs = {
                ...groupUAs,
                [GUA.id]: GUA,
              }
              actions.fetchingGroupUAsSuccess(newGroupUAs)
             }
           }).catch((err) => console.log(err))

       }).catch((err) => { console.error(err)});
    } else {
      // if we got back a GUA, then replace the active GUA with the new one
    const GUA = JSON.parse(res)
    newGroupUAs = {
      ...groupUAs,
      [GUA.id]: GUA,
    }
    actions.fetchingGroupUAsSuccess(newGroupUAs)
  }
  // otherwise make sure the new GUA displayed is null
  } else {
    if (groupUAs[selectedGroupUA]) {
      let nullGUA = {...groupUAs[selectedGroupUA]}
      if (nullGUA[`sy${year}`] && nullGUA[`sy${year}`][assessmentId]) {
        nullGUA[`sy${year}`][assessmentId] = null
      }
      newGroupUAs = {
        ...groupUAs,
        [selectedGroupUA]: nullGUA,
      }
    } 
    actions.fetchingGroupUAsSuccess(newGroupUAs)
  }
  
  if (selector_call) {
    actions.refreshingSuccess()
  } else {
    actions.updateState({updatingGUA: false})
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/processGroupUAUpdate.js